var _defs, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4c4c4c;}.cls-2{fill:#9bc5cc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M203.09,146.56,180.76,130a1.36,1.36,0,0,0-2.17,1.1V137a1.36,1.36,0,0,1-1.36,1.36H159.77a1.36,1.36,0,0,0-1.36,1.37v15.71a1.36,1.36,0,0,0,1.36,1.37h17.46a1.36,1.36,0,0,1,1.36,1.36v5.94a1.36,1.36,0,0,0,2.17,1.1l22.32-16.47A1.36,1.36,0,0,0,203.09,146.56Z",
    transform: "translate(-50 -50)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.87,199.39H150.34V100.61h15.53v30.55h6.75V97.23a3.4,3.4,0,0,0-1-2.39,3.36,3.36,0,0,0-2.38-1h-19A4.3,4.3,0,0,0,145.62,90l-45.3,4a4.34,4.34,0,0,0-4,4.32v99.25a4.32,4.32,0,0,0,3.58,4.27l45.3,8.07a4.29,4.29,0,0,0,5-3.78h19a3.36,3.36,0,0,0,2.38-1,3.4,3.4,0,0,0,1-2.39v-39h-6.75Zm-27.41-43.46c-1.86,0-3.38-2.66-3.38-5.93s1.52-5.93,3.38-5.93,3.38,2.65,3.38,5.93S140.33,155.93,138.46,155.93Z",
    transform: "translate(-50 -50)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.590ccde40f2f7c0ef8052a26fe130a5a.svg";
export { ForwardRef as ReactComponent };